/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ApiUserDataFromJSON, ApiUserDataToJSON, } from "./ApiUserData";
/**
 * Check if a given object implements the User interface.
 */
export function instanceOfUser(value) {
    let isInstance = true;
    isInstance = isInstance && "userdata" in value;
    return isInstance;
}
export function UserFromJSON(json) {
    return UserFromJSONTyped(json, false);
}
export function UserFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        userdata: ApiUserDataFromJSON(json.userdata),
    };
}
export function UserToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        userdata: ApiUserDataToJSON(value.userdata),
    };
}
